<sim-base-chip-input
	[formState]="assessmentTemplateFC"
	[label]="label"
	[placeholder]="placeholder"
	[isMultiSelect]="canSelectMultipleAssessments"
	[autoCompleteValues]="autoCompleteData"
	[debounceConfig]="{time: 200}"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
